import { ActivatedRoute } from '@angular/router';

export const resolveOrganisationIdFromRoute = (activated: ActivatedRoute) => {
  let orgId: string;
  try {
    let route = activated.snapshot;

    // Traverse up the router tree, duck-typing to find the organisation component
    while (route.parent && !route.params.organisationId) {
      route = route.parent;
    }

    orgId = route.params.organisationId;
    if (!orgId) {
      throw new Error('No organisationId in current router tree');
    }
    return orgId;
  } catch (err) {
    return null;
  }
};

export const resolveTenantIdFromRoute = (activated: ActivatedRoute) => {
  let tenantId: string;
  try {
    let route = activated.snapshot;

    // Traverse up the router tree, duck-typing to find the organisation component
    while (route.parent && !route.params.tenantId) {
      route = route.parent;
    }

    tenantId = route.params.tenantId;
    if (!tenantId) {
      throw new Error('No tenantId in current router tree');
    }
    return tenantId;
  } catch (err) {
    return null;
  }
};
